import { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import ProductOnLine from './ProductOnLine';
const Info = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch('/api/products/category/Informatique');
        const data = await response.json();
        setProducts(data);
      } catch (error) {
        console.error('Error fetching products:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <Row>
      {products.map(
        (product) =>
          product.type === 1 && (
            <Col key={product._id} sm={12} md={6} lg={4} xl={3}>
              <ProductOnLine product={product} />
            </Col>
          )
      )}
    </Row>
  );
};

export default Info;
